import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { debounceTime, forkJoin, Subscription, switchMap, tap } from 'rxjs';
import { DataInput, InfoDialogComponent }  from '@trivelope/triv-ui-tools-lib';
import { FormGroup } from '@angular/forms';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DocumentExchangeService } from 'src/app/services/document-exchange.service';
import { MatDialog } from '@angular/material/dialog';



@Component({
	selector: 'documentexchange-category-selector',
	templateUrl: './documentexchange-category-selector.component.html',
})
export class DocumentExchangeCategorySelectorComponent implements OnInit, OnDestroy {


	subscriptions = new Subscription();

	formG1 = new FormGroup({});
	myInputs: DataInput[] = [];
	@Input() userId = this.authenticationService.getCurrentUser().ebeId;
	@Input() memberId = "";

	bError = false;


	constructor(
		private authenticationService: AuthenticationService,
		private matSnackBar: MatSnackBar,
		private documentExchangeService: DocumentExchangeService,
		private matDialog: MatDialog
	) {}


	ngOnInit() {

		forkJoin( {
			categories: this.memberId
				? this.documentExchangeService.getDocumentExchangeCategoriesOfMember( this.memberId )
				: this.documentExchangeService.getDocumentExchangeCategories(),
			userCategories: this.documentExchangeService.getDocumentExchangeCategoriesOfUser( this.userId )
		} ).subscribe( result => {

			if( !result || !result.categories || !result.userCategories ) {
				this.bError = true;
				return;
			}

			const categories = result.categories;
			const userCategories = result.userCategories || [];

			const diValues: { [key: string]: boolean } = {};

			for( const category of categories ) {

				const bChecked = !!userCategories.find( uc => uc.id == category.id );

				const di = new DataInput();
				di.id = "" + category.id;
				di.type = "check";
				di.label = category.name;
				di.defaultValue = bChecked;
				this.myInputs.push( di );

				diValues[ category.id ] = bChecked;

			}

			setTimeout( () => {

				this.formG1.patchValue( diValues, { emitEvent: false } );

				for( const ctrlName in this.formG1.controls ) {
					if( !this.formG1.controls.hasOwnProperty(ctrlName) ) continue;

					const ctrl = this.formG1.get( ctrlName );
					if( !ctrl ) continue;

					this.subscriptions.add(
						ctrl.valueChanges.pipe(
							debounceTime( 300 ),
							switchMap( b => {

								return ( b
									? this.documentExchangeService.addDocumentExchangeCategoryToUser( this.userId, ctrlName )
									: this.documentExchangeService.removeDocumentExchangeCategoryOfUser( this.userId, ctrlName )
								).pipe(
									tap( b => {
										if( b ) {
											this.matSnackBar.open( 'Erfolgreiche Speicherung', 'Speichern' );
										}
										else {
											this.matDialog.open( InfoDialogComponent, {
												data: { title: 'Speichern', message: "Beim Speichern der Zuordnung für die Kategorie " + ctrlName + " ist ein Fehler aufgetreten" }
											});
										}
									})
								);

							})
						).subscribe()
					);

				}

			}, 1 );

		} );

	}

	ngOnDestroy() {

		this.subscriptions.unsubscribe();

	}


}

